import { apiRequest, buildURL } from './commons/CommonService.Functions';

// models
import {
  RelationShipTypeCreateCommand,
  RelationShipTypeUpdateCommand,
  RelationShipTypeViewModel
} from '../models/Entities/Person/RelationshipType/RelationshipTypeModels';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'persons/relationshiptypes';

// Get all relationship types
export const GetRelationshipTypes = async (
  token: string
): Promise<RelationShipTypeViewModel[]> => {
  return apiRequest<RelationShipTypeViewModel[]>(BaseURL, token, 'GetRelationshipTypes');
};

// Get relationship type by id
export const GetRelationshipTypeById = async (
  token: string,
  relationshipTypeId: number
): Promise<RelationShipTypeViewModel> => {
  const requestUrl: string = buildURL(BaseURL, relationshipTypeId);
  return apiRequest<RelationShipTypeViewModel>(requestUrl, token, 'GetRelationshipTypeById');
};

// Create relationship type
export const CreateRelationshipType = async (
  token: string,
  payload: RelationShipTypeCreateCommand
): Promise<RelationShipTypeViewModel> => {
  return apiRequest<RelationShipTypeViewModel>(BaseURL, token, 'CreateRelationshipType', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

// Update relationship type
export const UpdateRelationshipType = async (
  token: string,
  payload: RelationShipTypeUpdateCommand
): Promise<RelationShipTypeViewModel> => {
  return apiRequest<RelationShipTypeViewModel>(BaseURL, token, 'UpdateRelationshipType', {
    method: 'PUT',
    body: JSON.stringify(payload)
  });
};

// Delete relationship type
export const DeleteRelationshipType = async (
  token: string,
  relationshipTypeId: number
): Promise<number> => {
  const requestUrl: string = buildURL(BaseURL, relationshipTypeId);
  return apiRequest<number>(requestUrl, token, 'DeleteRelationshipType', {
    method: 'DELETE'
  });
};
